module.exports = {
  RFI_INSTRUCTIONS_PROVIDED: "rfiInstructionsProvided",
  RFI_INSTRUCTIONS_REQUIRED: "rfiInstructionsRequired",
  PRE_ADVICE_ONLY: "preadviceOnly",
  RFI_MISSING_DATA: "rfiMissingData",
  RFI_WATCH: "rfiWatch",
  RFI_RETURN: "rfiReturn",
  OVERDUE: "overdue",
  PRO_ALERT: "proAlert",
  RFI_EXCEPTION: "rfiException",
};
